import {
    LOGIN,
    LOGIN_SUCCESS,
    LOGOUT,
    SET_USER,
    UNSET_USER,
} from './_types';

export default {
    [LOGIN](state) {
        state.pending = true;
    },

    [LOGIN_SUCCESS](state) {
        state.isLoggedIn = true;
        state.pending = false;
    },

    [LOGOUT](state) {
        state.isLoggedIn = false;
    },

    [SET_USER](state, user) {
        state.user = user;
    },

    [UNSET_USER](state) {
        state.user = null;
    },
};



// WEBPACK FOOTER //
// ./src/infrastructure/auth/store/_mutators.js